import { Fight } from '../models/fight.model';
import { SeasonFights } from '../models/seasonFights.model';

export const createSeasonFightsFromFights = (
  fights: Fight[],
  startDate: Date,
  endDate: Date,
): SeasonFights[] => {
  return fights
    .filter((fight) => {
      const fightDate = new Date(fight.date);
      return fightDate >= startDate && fightDate <= endDate;
    })
    .map((fight) => ({
      fight_id: fight.id,
      date: fight.date,
      fighter_1: fight.fighter_1,
      fighter_2: fight.fighter_2,
      event_name: fight.name, // Fight.name is the event name
      gender: fight.gender,
      weight_class: fight.weight_class,
      title_fight: fight.title_fight,
      num_rounds: fight.num_rounds,
      fighter_1_id: fight.fighter_1_id,
      fighter_2_id: fight.fighter_2_id,
    }));
};
